import { generateSeoProps } from '../generateSeoProps';

export const getExpertsProps = () => {
    return generateSeoProps({
        title: 'Meet Our Pharma Experts | Pharmuni',
        canonical: 'experts',
        noIndex: false,
        description: `Meet the pharma mentors, instructors and career coaches behind Pharmuni. Our experts bring real experience from leading pharmaceutical companies to every course, review and coaching session.`,
    });
};

export const getExpertDynamicProps = ({ title = '', description = '', id = '', slug = '', image = '' }) => {
    return generateSeoProps({
        title: `${title} - Pharmuni Expert`,
        description: description,
        canonical: `experts/${id}/${slug}`,
        noIndex: false,
        image: image
    });
};

export const getExpertJsonLd = ({ expert, id = '', slug = '' }) => {
    const name = [expert?.first_name, expert?.last_name].filter(Boolean).join(' ');
    if (!name) return null;

    const jsonLd = {
        '@context': 'https://schema.org',
        '@type': 'Person',
        name,
        url: `https://pharmuni.com/experts/${id}/${slug}`,
        worksFor: {
            '@type': 'Organization',
            name: 'Pharmuni',
            sameAs: 'https://pharmuni.com'
        }
    };

    if (expert.job_title) jsonLd.jobTitle = expert.job_title;

    if (typeof expert.image === 'string' && expert.image.startsWith('http')) {
        jsonLd.image = expert.image;
    }

    // sameAs is the schema.org way to link a person to their other profiles.
    if (typeof expert.linkedin_url === 'string' && expert.linkedin_url.startsWith('http')) {
        jsonLd.sameAs = [expert.linkedin_url];
    }

    return jsonLd;
};
